// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_c4-2";
export var aiChatCartContainerExit = "_c4-4";
export var aiChatContainerLarge = "_c4-0";
export var aiChatContainerSmall = "_c4-1";
export var aiChatIcon = "_c4-6";
export var slideInFromRight = "_c4-3";
export var slideOutToRight = "_c4-5";